import { Box, Typography } from '@mui/material';
import { PageBase } from '../../PageBase';
import { theme } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const DataSecurity = () => {
  const { t } = useTranslation('dataSecurity');
  const navigate = useNavigate();

  return (
    <PageBase title={t('title')} onBackClick={() => navigate(-1)} paddingInline={0}>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {t('section_title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section_subtitle')}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('item1_description')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('item2_description')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('item3_description')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('item4_description')}
          </Typography>
        </Box>
      </Box>
    </PageBase>
  );
};
